import React from 'react';
import { Box, useTheme } from '@mui/material';
import DocumentCard from '../../components/DocumentCard';

function CorporateDocs({ files }) {
    const theme = useTheme();
    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.none}`,
                marginLeft: `-${theme.typography.generic.xSmall}`,
            }}
        >
            {files.map((cPdfData, index) => (
                <DocumentCard key={index} docData={cPdfData} />
            ))}
        </Box>
    );
}

export default CorporateDocs;
